import { Button, Modal, Typography } from 'antd'
import moment from 'moment'
import React from 'react'

import { DASHBOARD_HOME } from '../../variables'

export const AppEmbeddedVariables = (
  company = {},
  branchData = {},
  selectedAppointment = {},
  user = {},
  link = 'appointment'
) => [
  { name: '@COMPANY_NAME', value: company.companyName, empty: !company.companyName },
  {
    name: '@BRANCH_NAME',
    value: branchData.name || 'settings.messages.branchNameT',
    trans: !branchData.name,
    empty: !branchData
  },
  {
    name: '@BRANCH_ADDRESS',
    value: branchData.address || 'settings.messages.branchAddressT',
    trans: !branchData.address,
    empty: !branchData
  },
  {
    name: '@ROOM_NAME',
    value: selectedAppointment.room || branchData.rooms?.[0] || 'settings.messages.branchRoomT',
    trans: !branchData.rooms?.length,
    empty: !selectedAppointment.room
  },
  {
    name: '@BRANCH_PHONE',
    value: branchData.phones?.join(', ') || 'settings.messages.branchPhoneT',
    trans: !branchData.phones?.length,
    empty: !branchData.phones?.length
  },
  {
    name: '@DATE',
    value: moment(selectedAppointment.start || undefined).format(company.extraSettings?.dateFormat || 'LL'),
    empty: !selectedAppointment.start
  },
  {
    name: '@REMAINING',
    value: selectedAppointment.remaining || 1,
    empty: !selectedAppointment.remaining
  },
  {
    name: '@EXPIRES',
    value: moment(selectedAppointment.expires || undefined).format(company.extraSettings?.dateFormat || 'LL'),
    empty: !selectedAppointment.expires
  },
  {
    name: '@END_TIME',
    value: moment(selectedAppointment.end || undefined)
      .locale('en')
      .format('h:mm A'),
    empty: !selectedAppointment.end
  },
  {
    name: '@START_TIME',
    value: moment(selectedAppointment.start || undefined)
      .locale('en')
      .format('h:mm A'),
    empty: !selectedAppointment.start
  },
  {
    name: '@DAY',
    value: moment(selectedAppointment.start || undefined).format('dddd'),
    empty: !selectedAppointment.start
  },
  {
    name: '@DOCTOR_NAME',
    value: selectedAppointment.doctor?.name || 'settings.messages.doctorNameT',
    trans: !selectedAppointment.doctor,
    empty: !selectedAppointment.doctor
  },
  {
    name: '@DOCTOR_PHONE',
    value: selectedAppointment.doctor?.phoneNumber || 'settings.messages.doctorPhoneT',
    trans: !selectedAppointment.doctor || !selectedAppointment.doctor?.phoneNumber,
    empty: !selectedAppointment.doctor?.phoneNumber
  },
  {
    name: '@PATIENT_NAME',
    value: selectedAppointment?.patient
      ? `${selectedAppointment.patient.firstName} ${selectedAppointment.patient.lastName}`
      : user.firstName
      ? `${user.firstName} ${user.lastName}`
      : 'settings.messages.patientNameT',
    trans: !selectedAppointment.patient && !user.firstName,
    empty: !selectedAppointment.patient && !user.firstName
  },
  {
    name: '@FIRST_NAME',
    value: selectedAppointment?.patient?.fullName
      ? selectedAppointment.patient.fullName.split(' ')[0]
      : selectedAppointment?.patient
      ? selectedAppointment.patient.firstName
      : user.firstName
      ? user.firstName
      : 'settings.messages.firstNameT',
    trans: !selectedAppointment?.patient?.firstName && !user.firstName && !selectedAppointment?.patient?.fullName,
    empty: !selectedAppointment?.patient?.firstName && !user.firstName && !selectedAppointment?.patient?.fullName
  },
  {
    name: '@LEAD_NAME',
    value: selectedAppointment?.patient?.fullName || 'settings.messages.patientNameT',
    trans: !selectedAppointment?.patient?.fullName,
    empty: !selectedAppointment?.patient?.fullName
  },
  {
    name: '@PATIENT_TITLE',
    value: selectedAppointment?.patient?.title || user?.title || '',
    trans: true,
    empty: !selectedAppointment.patient && !user.title
  },
  {
    name: '@NOTE_TITLE',
    value: selectedAppointment.title || 'settings.messages.noteTitleT',
    trans: !selectedAppointment.title,
    empty: !selectedAppointment.title
  },
  {
    name: '@NOTE_DETAILS',
    value: selectedAppointment.details || 'settings.messages.noteDetailsT',
    trans: !selectedAppointment.details,
    empty: !selectedAppointment.details
  },
  {
    name: '@NOTE_USER_NAME',
    value: selectedAppointment.doctor ? selectedAppointment.doctor.name : user.name || 'settings.messages.userNameT',
    trans: !selectedAppointment.doctor && !user.name,
    empty: !selectedAppointment.doctor && !user.name
  },
  {
    name: '@USER_NAME',
    value: user.name || 'settings.messages.userNameT',
    trans: !user.name,
    empty: !user.name
  },
  {
    name: '@QR_CODE_LINK',
    value: selectedAppointment.id ? `${DASHBOARD_HOME}/${link}/${selectedAppointment.id}` : DASHBOARD_HOME,
    trans: false,
    empty: !selectedAppointment.id
  },
  {
    name: '@AMOUNT',
    value: selectedAppointment.amount || selectedAppointment.total || 0,
    trans: false,
    empty: isNaN(selectedAppointment.amount || selectedAppointment.total)
  },
  {
    name: '@POINTS_EXPIRES',
    value: selectedAppointment.patient?.patientPointsTxs?.expiresIn
      ? moment(selectedAppointment.patient?.patientPointsTxs.expiresIn).fromNow()
      : selectedAppointment.patient?.points?.firstToExpire
      ? moment(selectedAppointment.patient?.points?.firstToExpire).fromNow()
      : user?.points?.firstToExpire
      ? moment(user?.points?.firstToExpire).fromNow()
      : '',
    trans: false,
    empty: !selectedAppointment.patient?.patientPointsTxs && !selectedAppointment.patient?.points && !user?.points
  },
  {
    name: '@POINTS',
    value: String(
      selectedAppointment.patient?.patientPointsTxs?.points ||
        selectedAppointment.patient?.points?.remaining ||
        user?.points?.remaining ||
        0
    ),
    trans: false,
    empty: !selectedAppointment.patient?.patientPointsTxs && !selectedAppointment.patient?.points && !user?.points
  },
  {
    name: '@PATIENT_MEDICAL_QR_CODE',
    value:
      selectedAppointment.patient || user
        ? `${DASHBOARD_HOME}/medical/${selectedAppointment.patient?.id || user.id || ' '}`
        : DASHBOARD_HOME,
    trans: false,
    empty: !selectedAppointment.patient && !user
  },
  {
    name: '@PATIENT_ID',
    value: selectedAppointment.patient || user ? `${selectedAppointment.patient?.referenceId || user.referenceId || '1'}` : '',
    trans: false,
    empty: !selectedAppointment.patient && !user
  },
  {
    name: '@PATIENT_CUSTOM_ID',
    value: selectedAppointment.patient || user ? `${selectedAppointment.patient?.patientId || user.patientId || '1'}` : '#',
    trans: false,
    empty: !selectedAppointment.patient && !user
  }
]

const commonFields = [{ value: 'COMPANY_NAME', name: 'settings.messages.companyName' }]

const branchFields = [
  { value: 'BRANCH_PHONE', name: 'settings.messages.branchPhone' },
  { value: 'BRANCH_ADDRESS', name: 'settings.messages.branchAddress' },
  { value: 'BRANCH_NAME', name: 'settings.messages.branchName' }
]

const appointmentFields = [
  { value: 'ROOM_NAME', name: 'settings.messages.roomName' },
  { value: 'DOCTOR_NAME', name: 'settings.messages.doctorName' },
  { value: 'DOCTOR_PHONE', name: 'settings.messages.doctorPhone' },
  { value: 'QR_CODE_LINK', name: 'app.appointmentQrCodeLink' }
]

const timeFields = [
  { value: 'START_TIME', name: 'settings.messages.appointmentStart' },
  { value: 'END_TIME', name: 'settings.messages.appointmentEnd' },
  { value: 'DATE', name: 'settings.messages.appointmentDate' },
  { value: 'DAY', name: 'settings.messages.appointmentDay' }
]

const operationsFields = [
  { value: 'EXPIRES', name: 'app.expires' },
  { value: 'REMAINING', name: 'app.remainingPulses' }
]

const noteTimeFields = [
  { value: 'START_TIME', name: 'settings.messages.noteStart' },
  { value: 'END_TIME', name: 'settings.messages.noteEnd' },
  { value: 'DATE', name: 'settings.messages.noteDate' },
  { value: 'DAY', name: 'settings.messages.appointmentDay' }
]

const patientFields = [
  { value: 'FIRST_NAME', name: 'calendar.firstName' },
  { value: 'PATIENT_NAME', name: 'settings.messages.patientName' },
  { value: 'PATIENT_TITLE', name: 'settings.messages.patientTitle' },
  { value: 'PATIENT_ID', name: 'app.patientId' },
  { value: 'PATIENT_CUSTOM_ID', name: 'app.customId' },
  { value: 'PATIENT_MEDICAL_QR_CODE', name: 'support.medicalQrCode' }
]

const patientOnlyFields = [
  { value: 'POINTS', name: 'points.points' },
  { value: 'POINTS_EXPIRES', name: 'points.expiresIn' }
]

const noteFields = [
  { value: 'NOTE_TITLE', name: 'settings.messages.noteTitle' },
  { value: 'NOTE_DETAILS', name: 'settings.messages.noteDetails' },
  { value: 'NOTE_USER_NAME', name: 'settings.messages.noteUserName' }
]

const prescriptionFields = [{ value: 'QR_CODE_LINK', name: 'app.prescriptionQrCodeLink' }]
const labOrderFields = [{ value: 'QR_CODE_LINK', name: 'app.labOrderQrCodeLink' }]
const encounterFields = [{ value: 'QR_CODE_LINK', name: 'app.encounterQrCodeLink' }]
const freeFormFields = [{ value: 'QR_CODE_LINK', name: 'support.formQrCode' }]
const invoiceFields = [
  { value: 'AMOUNT', name: 'settings.inventory.amountTitle' },
  { value: 'QR_CODE_LINK', name: 'app.invoiceQrCodeLink' }
]
const quotationFields = [
  { value: 'AMOUNT', name: 'settings.inventory.amountTitle' },
  { value: 'QR_CODE_LINK', name: 'app.quotationQrCodeLink' }
]
const paymentFields = [
  { value: 'AMOUNT', name: 'settings.inventory.amountTitle' },
  { value: 'POINTS', name: 'points.points' },
  { value: 'POINTS_EXPIRES', name: 'points.expiresIn' },
  { value: 'QR_CODE_LINK', name: 'app.paymentQrCodeLink' }
]
const userField = [{ value: 'USER_NAME', name: 'settings.messages.userName' }]
const leadField = [
  { value: 'LEAD_NAME', name: 'common.name' },
  { value: 'FIRST_NAME', name: 'calendar.firstName' }
]

export const allFields = [
  ...commonFields,
  ...branchFields,
  ...appointmentFields,
  ...timeFields,
  ...patientFields,
  ...noteFields,
  ...userField,
  ...prescriptionFields,
  ...invoiceFields,
  ...paymentFields,
  ...encounterFields,
  ...leadField
]

export const appFieldsArr = [...commonFields, ...branchFields, ...appointmentFields, ...patientFields, ...timeFields]
export const noteFieldsArr = [...commonFields, ...branchFields, ...noteFields, ...noteTimeFields]
export const patientFieldsArr = [...commonFields, ...patientFields, ...patientOnlyFields]
export const prescriptionFieldsArr = [...commonFields, ...patientFields, ...prescriptionFields]
export const encounterFieldsArr = [...commonFields, ...patientFields, ...encounterFields]
export const labOrderFieldsArr = [...commonFields, ...labOrderFields]
export const freeFormFieldsArr = [...commonFields, ...patientFields, ...freeFormFields]
export const invoiceFieldsArr = [...commonFields, ...patientFields, ...invoiceFields]
export const quotationFieldsArr = [...commonFields, ...patientFields, ...quotationFields]
export const paymentFieldsArr = [...commonFields, ...patientFields, ...paymentFields]
export const userFields = [...commonFields, ...userField]
export const leadFieldsArr = [...commonFields, ...leadField]
export const operationsFieldsArr = [...commonFields, ...branchFields, ...operationsFields, ...patientFields]

export const hasEmptyValues = (values, mentionsArray, setFields, error) => {
  const emptyValues = allFields.filter(v => {
    return values.details.includes(`@${v.value}`) && !mentionsArray.find(field => field.value === v.value)
  })

  if (emptyValues.length) {
    setFields([
      {
        name: 'details',
        errors: [`${emptyValues.map(v => v.value).join(', ')} ${error}`]
      }
    ])
    return true
  }
  return false
}

export const renderMessageValues = ({ val, user, branchData, t, patient, appointment, returnEmpty, link, forWhatsApp }) => {
  let body = val || ''
  const empty = []
  AppEmbeddedVariables(user.company, branchData?.branchDetails, appointment, patient || {}, link).map(v => {
    const replace = new RegExp(v.name, 'g')
    if (v.empty && body.includes(v.name)) {
      empty.push(v.name)
    }
    return (body = body.replace(replace, forWhatsApp && !v.value ? 'Example' : v.trans ? t(v.value) : v.value || ''))
  })
  if (returnEmpty) return { body, empty }
  return body
}

export const handleConfirmEmpty = async (t, empty) => {
  if (!empty.length) return true
  return new Promise(resolve =>
    Modal.confirm({
      title: t('common.willBeEmpty'),
      okText: t('common.confirm'),
      content: (
        <Typography.Text type="warning" strong>
          {empty.join(', ')}
        </Typography.Text>
      ),
      maskClosable: false,
      onOk: () => resolve(true),
      onCancel: () => resolve(false)
    })
  )
}

export const handleConfirm = async (t, title, content, okButtonProps) => {
  return new Promise(resolve =>
    Modal.confirm({
      title,
      content,
      okButtonProps,
      okText: t('common.confirm'),
      maskClosable: false,
      onOk: () => resolve(true),
      onCancel: () => resolve(false)
    })
  )
}

export const handleConfirmWithCancel = async (t, title, content, okButtonProps) => {
  return new Promise(resolve => {
    const modalInstance = Modal.confirm({
      title,
      content,
      okButtonProps,
      okText: t('common.confirm'),
      cancelText: t('common.no'),
      maskClosable: false,
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <Button
            onClick={() => {
              resolve('abort')
              modalInstance.destroy() // Close only this modal
            }}
          >
            {t('app.abort')}
          </Button>
          <CancelBtn />
          <OkBtn />
        </>
      )
    })
  })
}

export const communicationTypes = [
  { value: 'SMS', title: 'sidebar.sms', color: 'blue', statusKey: 'status', pendingKey: 'pending' },
  {
    value: 'WA',
    title: 'app.whatsAppSettings',
    color: 'green',
    statusKey: 'waStatus',
    pendingKey: 'waPending'
  },
  {
    value: 'EMAIL',
    title: 'common.email',
    tag: 'app.soon',
    color: 'red',
    disabled: true,
    statusKey: 'emailStatus',
    pendingKey: 'emailPending'
  }
]

export const taskTypes = [
  { label: 'day', value: 'DAILY' },
  { label: 'week', value: 'WEEKLY' },
  { label: 'month', value: 'MONTHLY' }
]

export const taskPriority = [
  { label: 'High', value: 'HIGH', color: 'red-inverse' },
  { label: 'Medium', value: 'MEDIUM', color: 'gold-inverse' },
  { label: 'Low', value: 'LOW', color: 'cyan-inverse' }
]

export const clearEmbeddedVariable = str =>
  str ? str.replace(/[^a-zA-Z@_]/g, '').replace(/@/g, (match, index) => (index === str.indexOf('@') ? '@' : '')) : str

export const dynamicValuesToReplace = [
  '@COMPANY_NAME',
  '@BRANCH_PHONE',
  '@BRANCH_ADDRESS',
  '@BRANCH_NAME',
  '@ROOM_NAME',
  '@DATE',
  '@END_TIME',
  '@START_TIME',
  '@DAY',
  '@DOCTOR_NAME',
  '@DOCTOR_PHONE',
  '@PATIENT_NAME',
  '@FIRST_NAME',
  '@LEAD_NAME',
  '@PATIENT_TITLE',
  '@NOTE_TITLE',
  '@NOTE_DETAILS',
  '@NOTE_USER_NAME',
  '@QR_CODE_LINK',
  '@PATIENT_MEDICAL_QR_CODE',
  '@PATIENT_ID',
  '@PATIENT_CUSTOM_ID',
  '@EXPIRES',
  '@REMAINING',
  '@AMOUNT',
  '@POINTS'
]
